import { render, staticRenderFns } from "./transportationModel.vue?vue&type=template&id=c544fc0e&scoped=true"
import script from "./transportationModel.vue?vue&type=script&lang=js"
export * from "./transportationModel.vue?vue&type=script&lang=js"
import style0 from "./transportationModel.vue?vue&type=style&index=0&id=c544fc0e&lang=css"
import style1 from "./transportationModel.vue?vue&type=style&index=1&id=c544fc0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c544fc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c544fc0e')) {
      api.createRecord('c544fc0e', component.options)
    } else {
      api.reload('c544fc0e', component.options)
    }
    module.hot.accept("./transportationModel.vue?vue&type=template&id=c544fc0e&scoped=true", function () {
      api.rerender('c544fc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/transportationModel/transportationModel.vue"
export default component.exports